import { render, staticRenderFns } from "./CustomerOfferComponent.vue?vue&type=template&id=6fd22adb"
import script from "./CustomerOfferComponent.vue?vue&type=script&lang=ts"
export * from "./CustomerOfferComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports